// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QXJE","question":"styles_question__2f0d5","description":"styles_description__3OoD6"};